import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = { key: 7 }
const _hoisted_3 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_MetawebAttributeDetailDialog = _resolveComponent("MetawebAttributeDetailDialog")
  const _component_MetawebAttributeUnusedFieldDialog = _resolveComponent("MetawebAttributeUnusedFieldDialog")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.businessModel)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          class: "p-datatable-sm kn-table p-m-2",
          value: _ctx.businessModel.columns,
          loading: _ctx.loading,
          responsiveLayout: "stack",
          breakpoint: "960px",
          onRowReorder: _ctx.onRowReorder
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              rowReorder: true,
              headerStyle: _ctx.metawebAttributesTabDescriptor.reorderColumnStyle,
              reorderableColumn: false
            }, null, 8, ["headerStyle"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.metawebAttributesTabDescriptor.columns, (column, index) => {
              return (_openBlock(), _createBlock(_component_Column, {
                class: "kn-truncated",
                key: index,
                field: column.field,
                header: _ctx.$t(column.header)
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("div", _hoisted_1, [
                    (column.field === 'identifier')
                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                          key: 0,
                          modelValue: slotProps.data[slotProps.column.props.field],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                          binary: true,
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('metaUpdated')))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (column.field === 'visible')
                        ? (_openBlock(), _createBlock(_component_Checkbox, {
                            key: 1,
                            modelValue: _ctx.columnsVisibility[slotProps.data.uniqueName],
                            "onUpdate:modelValue": ($event: any) => (_ctx.columnsVisibility[slotProps.data.uniqueName] = $event),
                            binary: true,
                            onChange: ($event: any) => (_ctx.onChange(slotProps.data, 'visibility'))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                        : (column.field === 'personal')
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 2,
                              modelValue: _ctx.columnsPersonal[slotProps.data.uniqueName],
                              "onUpdate:modelValue": ($event: any) => (_ctx.columnsPersonal[slotProps.data.uniqueName] = $event),
                              binary: true,
                              onChange: ($event: any) => (_ctx.onChange(slotProps.data, 'personal'))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                          : (column.field === 'decrypt')
                            ? (_openBlock(), _createBlock(_component_Checkbox, {
                                key: 3,
                                modelValue: _ctx.columnsDecrypt[slotProps.data.uniqueName],
                                "onUpdate:modelValue": ($event: any) => (_ctx.columnsDecrypt[slotProps.data.uniqueName] = $event),
                                binary: true,
                                onChange: ($event: any) => (_ctx.onChange(slotProps.data, 'decrypt'))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                            : (column.field === 'subjectId')
                              ? (_openBlock(), _createBlock(_component_Checkbox, {
                                  key: 4,
                                  modelValue: _ctx.columnsSubjectId[slotProps.data.uniqueName],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.columnsSubjectId[slotProps.data.uniqueName] = $event),
                                  binary: true,
                                  onChange: ($event: any) => (_ctx.onChange(slotProps.data, 'subjectId'))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                              : (column.field === 'type')
                                ? (_openBlock(), _createBlock(_component_Dropdown, {
                                    key: 5,
                                    class: "kn-material-input",
                                    modelValue: _ctx.columnsType[slotProps.data.uniqueName],
                                    "onUpdate:modelValue": ($event: any) => (_ctx.columnsType[slotProps.data.uniqueName] = $event),
                                    options: _ctx.metawebAttributesTabDescriptor.typeOptions,
                                    onChange: ($event: any) => (_ctx.onChange(slotProps.data, 'type'))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"]))
                                : (column.field === 'name')
                                  ? (_openBlock(), _createBlock(_component_InputText, {
                                      key: 6,
                                      modelValue: slotProps.data[slotProps.column.props.field],
                                      "onUpdate:modelValue": ($event: any) => (slotProps.data[slotProps.column.props.field] = $event),
                                      class: "kn-material-input p-inputtext-sm p-p-2",
                                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('metaUpdated')))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(slotProps.data[slotProps.column.props.field]), 1))
                  ])
                ]),
                _: 2
              }, 1032, ["field", "header"]))
            }), 128)),
            _createVNode(_component_Column, {
              style: _ctx.metawebAttributesTabDescriptor.iconColumnStyle
            }, {
              header: _withCtx(() => [
                _createVNode(_component_Button, {
                  class: "kn-button kn-button--primary p-button-link p-jc-center",
                  onClick: _ctx.openUnusedFieldsDialog,
                  "data-test": "add-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              body: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_Button, {
                    icon: "far fa-edit",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.openAttributeDialog(slotProps.data)),
                    "data-test": 'open-icon-' + slotProps.data.name
                  }, null, 8, ["onClick", "data-test"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.deleteBusinessColumnConfirm(slotProps.data)),
                    "data-test": 'delete-icon-' + slotProps.data.name
                  }, null, 8, ["onClick", "data-test"])
                ])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value", "loading", "onRowReorder"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MetawebAttributeDetailDialog, {
      visible: _ctx.attributeDetailDialogVisible,
      selectedAttribute: _ctx.selectedAttribute,
      roles: _ctx.roles,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.attributeDetailDialogVisible = false)),
      onSave: _ctx.onAttributeSave
    }, null, 8, ["visible", "selectedAttribute", "roles", "onSave"]),
    _createVNode(_component_MetawebAttributeUnusedFieldDialog, {
      visible: _ctx.unusedFieldDialogVisible,
      unusedFields: _ctx.unusedFields,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.unusedFieldDialogVisible = false)),
      onSave: _ctx.saveUnusedFields
    }, null, 8, ["visible", "unusedFields", "onSave"])
  ]))
}